import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullRegion from "../fragments/fullRegion"

const query = gql`
  query AllRegions {
    allRegions {
      results {
        ...fullRegion
      }
    }
  }
  ${fullRegion}
`

export const allRegionsKey = getQueryNames(query)[0]

export default query
